import React from 'react'
import { BsGithub } from 'react-icons/bs'
import { FaFacebookF } from 'react-icons/fa'
import { FaLinkedin } from 'react-icons/fa'
import { TiLink } from 'react-icons/ti'

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <a href="https://torre.co/joseriveradl" target="_blank" rel="noopener noreferrer">
        <div>
          <TiLink />
        </div>
      </a>
      <a href="https://www.linkedin.com/in/josé-rivera-61a224259" target="_blank" rel="noopener noreferrer">
        <div>
          <FaLinkedin />
        </div>
      </a>
      <a href="https://github.com/J0seRivera" target="_blank" rel="noopener noreferrer">
        <div>
          <BsGithub />
        </div>
      </a>
      <a href="https://www.facebook.com/jose.riveradl" target="_blank" rel="noopener noreferrer">
        <div>
          <FaFacebookF />
        </div>
      </a>
    </div>
  )
}

export default SocialMedia